import { useTranslation } from 'react-i18next'

import { useCartInfoStore, useCartStore } from '@entities/Cart'

import { URL_CART } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'



interface CartLinkProps {
  className?: string;
}

export default function CartLink (props: CartLinkProps) {
  const { t: tc } = useTranslation('common')
  const { className } = props
  const { getTotalQuantity } = useCartStore()
  const cartInfo = useCartInfoStore((state) => state.cartInfo)

  const itemCount = getTotalQuantity()
  const totalAmount = cartInfo?.totals?.total

  return (
    <Button
      className={cn(className, styles.link)}
      theme="grey"
      size="large"
      to={URL_CART}
    >
      {(!itemCount || !totalAmount) && (
        <>
          <img
            src="/icons/cart.svg"
            alt=""
            loading="lazy"
            fetchPriority="low"
          />
          {tc('cart.button')}
        </>
      )}

      {!!itemCount && totalAmount && (
        <>
          <img
            src="/icons/shopping-bag.svg"
            alt=""
            loading="lazy"
            fetchPriority="low"
          />
          {formatPrice(totalAmount)}
        </>
      )}

      {!!itemCount && (
        <span className={styles.link__count}> {itemCount}</span>
      )}
    </Button>
  )
}
